import adminCP from './admincp'
import commodity from './commodity'
import company from './company'
import costing from './costing'
import customer from './customer'
import dashboard from './dashboard'
import driver from './driver'
import journey from './journey'
import order from './order'
import partner from './partner'
import price from './price'
import quote from './quote'
import route from './route'
import sellingPrice from './selling-price'
import trip from './trip'
import vehicle from './vehicle'
import vendor from './vendor'

export default {
  ...vehicle,
  ...driver,
  ...customer,
  ...commodity,
  ...vendor,
  ...order,
  ...partner,
  ...costing,
  ...price,
  ...quote,
  ...trip,
  ...company,
  ...dashboard,
  route,
  ...journey,
  adminCP,
  ...sellingPrice
}
